// extracted by mini-css-extract-plugin
export default {"informalStatsContainer":"NYriEl0XrvkYElpWwNyA","statsContainer":"uSQv1Vo0Hswdtzmv3LmD","title":"nJCWpczUizUJLku96Vuq","separator":"X7giDwvwuQ8Xho0K5M3b"};